// ====================================== Define constants ========================================
// Reduces server calls if a product has a crazy number of images.
const BAMBUSER_MAX_IMAGES_COUNT = 6;

// Extracts product handle from the product URL
const SHOPIFY_PRODUCT_URL_HANDLE_REGEX = /\/products\/(.[\w\d-+]+)/;

// ====================================== General helper methods for Shopify  ========================================
// Sometimes image URLs miss the protocol at the beginning
// E.g. '//cdn.shopify.com/s/files/.../image.jpg'
window.urlSanitizer = (url) => {
  if (typeof url === 'string') {
    if (url.startsWith('//')) return `https:${url}`;
    else if (url.toLocaleLowerCase().startsWith('http')) return url;
    else console.log(`Not a valid URL: ${url}`);
  } else console.log(`Not a valid URL: ${url}`);
  return null;
};

// Returns the store's active currency for the current user
// E.g,: 'EUR'
window.getActiveCurrency = () => {
    // 1. From the Shopify object
    const getCurrencyFromContext = Shopify?.currency?.active;
    if (getCurrencyFromContext) return getCurrencyFromContext;

    // 2. From the 'cart_currency' cookie
    const currencyFromCookies = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cart_currency'))
      ?.split('=')[1];
    if (currencyFromCookies) return currencyFromCookies;

    // If no currency found
    return null;
  };

window.getLocale = () => {
  var l = Shopify?.locale ?? 'en';
  /*var c = Shopify?.country ?? 'GB';*/
  var c = l=='en'?'GB':l.toUpperCase();
console.log(42, l + '-' + c);
  return l + '-' + c;
};

window.updateThirdPartyCartFn = () => {
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer().refresh();
  }
  if (typeof Cart !== 'undefined') {
    new Cart().renderContents(parsedState);
  }
};

//========== Shopify Ajax API Helper methods ===============

window.oneToManyStoreApi = {};

oneToManyStoreApi.getProductByUrl = (url) => {
  const handle = SHOPIFY_PRODUCT_URL_HANDLE_REGEX.exec(url);
  try {
    if (typeof handle[1] == 'string' && handle[1].length > 0) {
      return fetch('/products/' + handle[1] + '.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((resp) => resp.json());
    }
  } catch (error) {
    throw new Error(
      'Cannot find the handle in the product URL: ' + url + '/n' + error
    );
  }
};

oneToManyStoreApi.addToCart = (itemId) =>
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          quantity: 1,
          id: itemId,
        },
      ],
    }),
  }).then((resp) => resp.json());

oneToManyStoreApi.updateItemInCart = (itemId, quantity) =>
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      updates: {
        [itemId]: quantity,
      },
    }),
  }).then((resp) => resp.json());

oneToManyStoreApi.getCartState = () =>
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((resp) => resp.json());

oneToManyStoreApi.getVariantIdFromUrlParams = (url) => {
  // Extract the variant ID from the URL
  // URL Ex. https://www.MY-SHOPIFY-STORE.com/products/my-product-handle?variant=VARIATION_ID
  const variantId = new URL(url).searchParams.get('variant');
  return typeof variantId == 'string' && variantId.length == 14
    ? variantId
    : null;
};

//=========== Bambuser onReady Handler =================

window.onBambuserLiveShoppingReady = (player) => {
  // ---- Start of player configuration ----
  player.configure({
    currency: getActiveCurrency() || 'USD',
    locale: getLocale() || 'en-US',
    buttons: {
      dismiss: player.BUTTON.CLOSE,
    },
  });
  // ---- End of player configuration ----

  // ---- Start of Cart Integrations ----
  player.on(player.EVENT.ADD_TO_CART, (addedItem, callback) => {
    oneToManyStoreApi
      .addToCart(addedItem.sku)
      .then((res) => {
        if (res.items) {
          callback(true);
          console.log('Item added succussfully!');

          /*shopify theme update cart wrapper*/
          updateThirdPartyCartFn();
        } else if (res.description && res.description.includes('sold out')) {
          callback({ success: false, reason: 'out-of-stock' });
        } else callback(false);
      })
      .catch((error) => {
        callback(false);
        console.error('Add to cart error! ', error);
      });
  });

  player.on(player.EVENT.UPDATE_ITEM_IN_CART, (updatedItem, callback) => {
    console.log(
      `Cart updated! ${updatedItem.previousQuantity} --> ${updatedItem.quantity}`
    );
    oneToManyStoreApi
      .updateItemInCart(updatedItem.sku, updatedItem.quantity)
      .then((res) => {
        if (res.items) {
          callback(true);
          console.log('Item updated succussfully!');

          /*shopify theme update cart wrapper*/
          updateThirdPartyCartFn();
        } else callback(false);
      })
      .catch((error) => {
        callback(false);
        console.error('Error on updating item! ', error);
      });
  });

  player.on(player.EVENT.SYNC_CART_STATE, () => {
    // Use your method to check if the user has checkout
    oneToManyStoreApi.getCartState().then((res) => {
      if (res.item_count == 0) {
        // Emptying the in-player cart
        player.updateCart({
          items: [],
        });
      }
    });
  });

  player.on(player.EVENT.CHECKOUT, () => {
    // Use the showCheckout() method to safely
    // navigate the user to your checkout page
    player.showCheckout(window.location.origin + '/cart/checkout');
  });
  // ---- End of Cart Integrations ----

  // ---- Start of Product Hydration ----
  player.on(player.EVENT.PROVIDE_PRODUCT_DATA, (event) => {
    // Iterates over all the products you have added to the show on the workspace
    event.products.forEach(({ ref: sku, id, url }) => {
      const variantId = oneToManyStoreApi.getVariantIdFromUrlParams(url);
      try {
        // Your method to fetch a product data
        oneToManyStoreApi.getProductByUrl(url).then((item) => {
          //Uncomment the line below for debugging retrieved product data
          //console.log(item);
          player.updateProduct(id, (productFactory) =>
            productFactory.product((detailsFactory) =>
              detailsFactory
                .name(item.title)
                .sku(item.id)
                .brandName(item.vendor)
                .description(item.description)
                .defaultVariationIndex(
                  variantId
                    ? item.variants.findIndex(
                        (variant) => variant.id == variantId
                      )
                    : 0
                )
                .variations((variationFactory) =>
                  item.variants.map((variation) =>
                    variationFactory()
                      .attributes((attributeFactory) =>
                        attributeFactory.colorName(variation.title)
                      )
                      .imageUrls([
                        // Adding the featured image of the chosen variation (if existed) at the beginning of the images array
                        ...(variation.featured_image
                          ? [variation.featured_image.src]
                          : []),
                        // Adding product imgaes
                        ...item.images
                          .slice(0, BAMBUSER_MAX_IMAGES_COUNT - 1)
                          .map((url) => urlSanitizer(url))
                          .filter((url) => typeof url === 'string'),
                      ])
                      .name(variation.title)
                      .sku(item.id)
                      .sizes((sizeFactory) => [
                        sizeFactory()
                          .name(variation.title)
                          .sku(variation.id)
                          .inStock(variation.available)
                          .price((priceFactory) =>
                            priceFactory
                              .original(variation.compare_at_price / 100)
                              .current(variation.price / 100)
                          ),
                      ])
                  )
                )
            )
          );
        });
      } catch (error) {
        console.warn('CANNOT HYDRATE THE PRODUCT! \n', error);
      }
    });
  });
};

/* bambuser default */
if (!window.initBambuserLiveShopping){
  window.initBambuserLiveShopping = function(item) { window.initBambuserLiveShopping.queue.push(item) }; window.initBambuserLiveShopping.queue = [];
  var scriptNode = document.createElement('script');
  scriptNode['src'] = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
  document.body.appendChild(scriptNode);
}

document.addEventListener("DOMContentLoaded", function() {
    if (!window.initBambuserLiveShopping){
      window.initBambuserLiveShopping = function(item) { window.initBambuserLiveShopping.queue.push(item) }; window.initBambuserLiveShopping.queue = [];
      var scriptNode = document.createElement('script');
      scriptNode['src'] = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
      document.body.appendChild(scriptNode);
    }

    bambuserButtons = document.querySelectorAll('.bambuser-show-play:not(.hidden)');
    bambuserButtons.forEach(button => {
      window.initBambuserLiveShopping({
        showId: button.dataset.showId,
        node: button,
        type: "overlay",
      });
    });

  let bambuserShoppableVideoButton = document.querySelectorAll('.bambuser-shoppable-video-trigger');
  if(bambuserShoppableVideoButton.length > 0){
    bambuserShoppableVideoButton.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let bam_playlist = e.target.closest('.bambuser-shoppable-video-trigger').dataset.bamPlaylistId;
        document.querySelector('#'+bam_playlist)?.shadowRoot?.querySelector('bam-player')?.click();
      });
    });
  }

});
/* end default */

class BambuserCustom extends HTMLElement {
  constructor() {
    super();
    this.ss = 'Bt9bJiyLjn741hLLHWBzXMxn9xep59mZVdQieP5wzWtD';
    this.base_url = 'https://liveshopping-api-eu.bambuser.com/v1';
    this.locale = window.getLocale() || 'en-US';
  }

  getShow(show_id, callback = null) {
    if(!show_id) return false;
    var body = {};
    this.fetchData(`/shows/${show_id}`, "GET", body, {}, callback);
  }

  getShowByProduct(bambuser_show_play = null, product_id = null, show_id = null){
    if(!product_id) return false;
    var body = {productReference: product_id}; /*supports multiple productReference*/
    this.fetchData("/products/highlighted/shows/by-references", "GET", body, {}, data => {
      let shows_with_this_product = data?.results?.find(item => item.productReference == product_id);
      shows_with_this_product = shows_with_this_product?.appearances ?? [];
      if(shows_with_this_product?.length < 1) {
        /*no shows found*/
        if(bambuser_show_play && show_id){
          this.getShow(show_id, this.setThumb);
          return false;
        }
        return [];
      }

      shows_with_this_product = shows_with_this_product.filter(obj => obj?.showData?.published === true);

      if(!bambuser_show_play) {
        /*if no button provided -> just return the list of the shows with this product*/
        return shows_with_this_product;
      }

      let show;
      if(show_id){
        show = shows_with_this_product.find(item => item.showId);
        if(!show) return;
      } else {
        show = shows_with_this_product[shows_with_this_product.length - 1];
      }

      bambuser_show_play.setAttribute('data-show-id', show.showId);
      bambuser_show_play.classList.remove('hidden');
      window.initBambuserLiveShopping({
        showId: bambuser_show_play.dataset.showId,
        deeplink: show.deeplink,
        node: bambuser_show_play,
        type: "overlay",
      });

      this.setThumb({id: show.showId, ...show.showData});
    });
  }

  fetchData(url, method = "GET", body = null, headers = {}, callback = null) {
    //try {
      url = new URL(this.base_url + url);
      const options = {
        method,
        headers: {
          "Authorization": ("Token " + this.ss),
          "Content-Type": "application/json",
          ...headers
        }
      };

      if(body){
        if(method == "POST"){
          options.body = JSON.stringify(body);
        } else {
          url.search = new URLSearchParams(body);
        }
      }

      fetch(url, options)
        .then(response => {
          if(!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if(typeof callback == 'function'){
            callback.call(this, data);
          }
        })
    //}
  }
  
  customFormatDate(date) {
    if(!date) return '';
    date = new Date(date);
    return date.toLocaleDateString(this.locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}

class BambuserCustomButton extends BambuserCustom {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.bambuser-show-play');

    this.buttons.forEach(btn => {
      if(btn.dataset.showMethod == 'auto'){
        this.getShowByProduct(btn, btn.dataset.productId);
      }
      else if(typeof btn.dataset.startFromRef !== "undefined" && btn.dataset.startFromRef){
        this.getShowByProduct(btn, btn.dataset.productId, btn.dataset.showId);  
      }
      else if(btn.dataset.getData){
        this.getShow(btn.dataset.showId, this.setThumb);
      }
    });
  }

  setThumb(data) {
    if(!data.id) return false;
    let btns = this.querySelectorAll(`.bambuser-show-play[data-show-id="${data.id}"]`);
    btns?.forEach(btn => {
      btn.querySelector('.bam-thumb')?.setAttribute('src', data.preview);
      btn.querySelector('.bam-thumb')?.setAttribute('alt', data.title.replace(/"/g, '\\"'));
    })
  }
}

if (!customElements.get('bambuser-custom-button')) {
  customElements.define('bambuser-custom-button', BambuserCustomButton);
}

class BambuserGallery extends BambuserCustom {
  constructor() {
    super();
    this.shows_wrapper = this.querySelector('.bambuser-gallery-content');
    this.load_more = this.querySelector('.bambuser-load-more');

    this.tags_wrapper = this.querySelector('.bambuser-tags');

    this.next_page_code = false;
    this.per_page = this.dataset.perPage ?? 3;
    this.tag_active = 'all';
    this.filter_state = this.dataset.filterState ?? 'ended';
    this.filter_is_published = this.dataset.filterIsPublished ?? 'all';

    if(this.tags_wrapper){
      this.tags = this.tags_wrapper.querySelectorAll('a');
      this.tags.forEach(tag => {
        tag.addEventListener('click', event => {
          this.tags_wrapper.querySelector('.active')?.classList?.remove('active');
          event.target.classList.add('active');
          this.tag_active = event.target.getAttribute('href')?.replace('#','') ?? 'all';
          this.next_page_code = false;
          this.getShows(true);
        });
      });
    }

    this.load_more?.addEventListener('click', event => {
      this.getShows(false);
    });

    this.getShows(true);
  }
  
  getShows(clean_old_results = false) {
    if(clean_old_results){
      this.shows_wrapper.innerHTML = '';
    }
    var body = {
      limit: this.per_page,
      state: this.filter_state
    };
    if(this.next_page_code){
      body.after = this.next_page_code;
    }
    if(this.tag_active != 'all'){
      body.tag = this.tag_active;
    }
    if(this.filter_is_published=="true"||this.filter_is_published=="false"){
      body.isPublished = this.filter_is_published;
    }

    this.fetchData("/shows", "GET", body, {}, this.renderShows);
  }
  
  renderShows(data) {
    this.next_page_code = data.next;
    if(this.next_page_code){
      this.load_more?.removeAttribute('disabled');
    } else {
      this.load_more?.setAttribute('disabled', 'disabled');
    }

    data.results.forEach(item => {
      var show_date = item.startedAt ?? item.scheduledStartAt;

      var new_show = document.createElement('div');
      new_show.classList.add('column', 'image-with-text__image', 'no-grayscale-hover');
      new_show.innerHTML = '<div class="image-with-text__image-media aspect-ratio">'
        +   '<img src="'+ item.preview +'" alt="'+ item.title.replace(/"/g, '\\"') +'" />'
        +   '<button class="bambuser-show-play image-with-text__image-media--overlay" data-show-id="'+ item.id +'" type="button">'
        +     '<span class="bambuser-live-label '+ (item.isLive ? '' : 'bambuser-live-label--invert hidden') +' h5">'+ (item.isLive ? window.theme.strings.bambuserLive : window.theme.strings.bambuserDefaultLabel) +'<sup>&bull;</sup></span>'
        +     '<span class="icon-play"></span>'
        +     '<p class="subheading">'+ this.customFormatDate(show_date) +'</p>'
        +     '<p class="h5 heading">'+ item.title +'</p>'
        +     '<p class="subheading small-hidden">'+ item.description +'</p>'
        +   '</button>'
        + '</div>';
      this.shows_wrapper.appendChild(new_show);

      var button = new_show.querySelector('.bambuser-show-play');
      window.initBambuserLiveShopping({
        showId: button.dataset.showId,
        node: button,
        type: "overlay"
      });
    });
  }
}

if (!customElements.get('bambuser-gallery')) {
  customElements.define('bambuser-gallery', BambuserGallery);
}
